//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    universe: string;
    id: number;
    body: {
        date_from: string;
        date_to: string;
        display_order: number;
        event_id: number;
        header_bg_color?: null | undefined | string;
        header_img_big: string;
        header_img_medium: string;
        header_img_small: string;
        is_active_promo: boolean;
        is_active_widget: boolean;
        market_id: number;
        promo_bg_color?: null | undefined | string;
        promo_img_big: string;
        promo_img_medium: string;
        promo_img_small: string;
        subtitle?: null | undefined | string;
        tc_text?: null | undefined | string;
        tc_title?: null | undefined | string;
        title: string;
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /website-cms/{universe}/hero-widget/{id} -> put -> ${code}`);
    };
};

export const Response200IO = t.number;
export type Response200Type = number;
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response500IO = t.unknown;
export type Response500Type = unknown;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiWebsiteCmsUpdateHeroWidgetRequest"
 */
export const openapi_website_cms_updateHeroWidget = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/website-cms/${params.universe}/hero-widget/${params.id}${query}`;
    
    const method = 'PUT';
    const paramsFetch = {
        url,
        body: params.body,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiWebsiteCmsUpdateHeroWidgetParamsType = ParamsType;

export type OpenapiWebsiteCmsUpdateHeroWidgetResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiWebsiteCmsUpdateHeroWidgetResponse200Type = Response200Type;

export const openapiWebsiteCmsUpdateHeroWidgetRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiWebsiteCmsUpdateHeroWidgetResponseType> => {
    const response = await openapi_website_cms_updateHeroWidget(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiWebsiteCmsUpdateHeroWidgetRequest - unhandled response ${response.status}`);
};

